import { render, staticRenderFns } from "./board-folder.vue?vue&type=template&id=3a0270b6&scoped=true&"
import script from "./board-folder.vue?vue&type=script&lang=ts&"
export * from "./board-folder.vue?vue&type=script&lang=ts&"
import style0 from "./board-folder.vue?vue&type=style&index=0&id=3a0270b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0270b6",
  null
  
)

export default component.exports